export default "__VITE_ASSET__DjAUi$5Y__"